import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
import { Animated } from "react-animated-css";
import { Modal, ModalBody, ModalFooter, Input, FormGroup, Label } from "reactstrap";

import api from "../services/Api";
import { auth } from "../services/Firebase";

import DadosForm from "./Dispositivos/DadosForm";
import DispositivosList from "./Dispositivos/DispositivosList";
import Loading from "./Loading";

const motivo = {
  0: "Selecione",
  1: "Negociei meu aparelho com outra pessoa",
  2: "Aparelho com avaria / desuso",
  3: "Outro motivo",
};

class Dispositivos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ModalTitle: <p style={{ color: "black" }}>Atenção</p>,
      isAuthing: true,
      isLoggedIn: false,
      data: null,
      dispositivos: [],
      logDispositivos: [],
      dispositivo: null,
      showForm: false,
      showButton: false,
      userUid: this.props.userUid,
      userId: this.props.userId,
      modal: false,
      modalMotivo: false,
      enableDelete: false,
      idDisp: "",
      triplice: {},
      DinamicBo: false,
      showDelete: false,
      tablesTransition: false,
      loadList: false,
    };
  }

  async componentDidMount() {
    await this.handlePush();
    await auth.onAuthStateChanged((data) => {
      this.setState({
        isAuthing: false,
        isLoggedIn: !!data,
        data: data,
      });
    });
  }
  // carrega os dados das apis e verifica se o usuario existe

  componentWillMount = () => {
    api.loadAux().then((resp) => {
      const triplice = resp.data[0];
      this.setState({ triplice: triplice });
    });
  };
  // carrega os dados tas tabelas auxiliares

  componentWillUnmount() {
    this.setState({
      isAuthing: undefined,
      isLoggedIn: undefined,
      data: undefined,
      dispositivos: undefined,
      dispositivo: undefined,
      showForm: undefined,
      showButton: undefined,
      modal: undefined,
      enableDelete: undefined,
      userUid: undefined,
    });
  }
  // desmostando os estados do react

  changeModal = () => {
    this.setState({ modal: !this.state.modal });
    this.setState({ enableDelete: false });
  };
  // modal

  testClick = (e) => {
    e.preventDefault();
    const value = e.target.value;
    if (value !== null && value !== "0") {
      this.setState({ enableDelete: true });
    } else {
      this.setState({ enableDelete: false });
    }
  };

  handleRefresh = (event) => {
    this.componentDidMount();
  };
  //reload

  handlePush = async (event) => {
    await this.setState({ loadList: false });

    await api
      .loadDispositivosByUid(this.props.userUid)
      .then((resp) => {
        this.setState({ dispositivos: resp.data, loadList: true });
      })
      .catch((e) => {
        if (e.response.status === 401) this.props.onModalToken();
      });

    await api
      .logDispositivosId(this.props.userId)
      .then((resp) => {
        this.setState({ logDispositivos: resp.data });
      })
      .catch((e) => {
        if (e.response.status === 401) this.props.onModalToken();
      });
  };
  //função que consome as apis

  handleDelete = async (motivo) => {
    var Dispositivos = this.state.idDisp;
    await api
      .loadDispositivosByid(Dispositivos)
      .then((resp) => {
        resp.data.motivo = motivo;
        resp.data.id_device = resp.data.id;
        resp.data.user_id = this.props.userId;
        resp.data.created_disp = resp.data.created_at;
        resp.data.userUid = resp.data.useruid;
        api
          .deleteDispositivos(resp.data)
          .then(async (resp) => {
            await this.changeModal();
            await this.handleRefresh();
          })
          .catch((e) => {
            if (e.response.status === 401) this.props.onModalToken();
          });
      })
      .catch((e) => {
        if (e.response.status === 401) this.props.onModalToken();
      });
  };
  //deleta um dispositivo

  handleDeleteId = (valor) => {
    this.changeModal();
    this.setState({ idDisp: valor });
  };
  //pega o id e altera o estado e chama o modal

  handleEdit = (id) => {
    let dispositivo = null;
    for (let i = 0; i < this.state.dispositivos.length; i++) {
      if (this.state.dispositivos[i].id === id) {
        dispositivo = this.state.dispositivos[i];
      }
    }
    if (dispositivo) {
      this.setState({ dispositivo: dispositivo });
    }
    if (dispositivo.numero_bo == null) {
      this.setState({ DinamicBo: false });
    } else {
      this.setState({ DinamicBo: true });
    }
    this.setState({
      showForm: true,
      showButton: true,
    });
  };
  //edicao do dispositivo

  handleShowForm = (event) => {
    if (this.state.dispositivo) {
      this.setState({ DinamicBo: true });
    } else {
      this.setState({ DinamicBo: false });
    }
    this.setState({ showForm: !this.state.showForm });
    this.handleClearForm();
  };
  //mostra o formulario

  handleClearForm = (event) => {
    this.setState({ dispositivo: null });
  };
  //limpa os dispositivos
  cancelei = (event) => {
    this.setState({ showForm: !this.state.showForm });
  };
  //altera o estado do botão do formulario
  handleShowButton = (event) => {
    this.setState({ showButton: !this.state.showButton });
  };
  //altera o estado do showButton

  render() {
    if (this.state.isAuthing) return <Loading />;

    if (!this.state.isLoggedIn) return <Redirect to="/" />;

    return (
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12">
          <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={this.state.showForm}>
            {this.state.showForm ? (
              <DadosForm
                onModalToken={this.props.onModalToken}
                userUid={this.state.userUid}
                userId={this.state.userId}
                dispositivo={this.state.dispositivo}
                handlePush={this.handlePush}
                handleShowButton={this.handleShowButton}
                handleShowForm={this.handleShowForm}
                handleClearForm={this.handleClearForm}
                cancelei={this.cancelei}
                operadoras={this.state.operadoras}
                situacoes={this.state.situacoes}
                marcas={this.state.marcass}
                triplice={this.state.triplice}
                DinamicBo={this.state.DinamicBo}
                allUser={this.props.allUser}
              />
            ) : null}
          </Animated>

          <div>
            <h4 style={{ fontWeight: "bold" }}>
              Dispositivos
              {this.state.showDelete ? ` excluídos` : ` ativos`}
              <span
                id={this.state.showDelete ? "countLogDispositivos" : "countDispositivos"}
                className="ml-2 badge badge-light"
              >
                {this.state.showDelete
                  ? this.state.logDispositivos.length
                  : this.state.dispositivos.length}
              </span>
              <UncontrolledTooltip
                target={this.state.showDelete ? "countLogDispositivos" : "countDispositivos"}
                delay={{ show: 0, hide: 0 }}
              >
                Quantidade de dispositivos{this.state.showDelete ? ` excluídos` : ` cadastrados`}:
                <strong>
                  {this.state.showDelete
                    ? this.state.logDispositivos.length
                    : this.state.dispositivos.length}
                </strong>
              </UncontrolledTooltip>
              {!this.state.showForm ? (
                <button className="btn btn-primary ml-2" onClick={this.handleShowForm}>
                  Adicionar
                </button>
              ) : null}
              <FormGroup className="btn-deletados" inline row check>
                <Label check>
                  <Input
                    type="checkbox"
                    value={this.state.showDelete}
                    onClick={() =>
                      this.setState({
                        showDelete: !this.state.showDelete,
                        tablesTransition: !this.state.tablesTransition,
                      })
                    }
                  />{" "}
                  Dispositivos Deletados
                </Label>
              </FormGroup>
            </h4>
          </div>

          <DispositivosList
            handleEdit={this.handleEdit}
            handleDelete={this.handleDelete}
            showButton={this.showButton}
            list={this.state.dispositivos}
            loglist={this.state.logDispositivos}
            modal={this.state.modal}
            changeModal={this.changeModal}
            deleteFade={this.testClick}
            enableDelete={this.state.enableDelete}
            handleDeleteId={this.handleDeleteId}
            triplice={this.state.triplice}
            showDelete={this.state.showDelete}
            tablesTransition={this.state.tablesTransition}
            handlePush={this.handlePush}
            loadList={this.state.loadList}
          />
        </div>
        <Modal isOpen={this.state.modal} style={{ color: "black" }}>
          <ModalBody>
            <p>
              Caso o dispositivo seja excluído, não há como recuperá-lo. Será necessário cadastrá-lo
              novamente.
            </p>
            <br />
            <p>Nos informe o motivo da remoção do dispositivo:</p>
            <Input type="select" onChange={this.testClick} innerRef={(ref) => (this.marca = ref)}>
              {Object.keys(motivo).map((key) => (
                <option key={key} value={key}>
                  {motivo[key]}
                </option>
              ))}
            </Input>
          </ModalBody>
          <ModalFooter>
            <button
              className="btn btn-danger"
              disabled={this.state.enableDelete === false}
              onClick={() => {
                this.handleDelete(this.marca.value);
              }}
            >
              Deletar
            </button>
            <button className="btn btn-primary" onClick={this.changeModal}>
              Cancelar
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export default Dispositivos;



// WEBPACK FOOTER //
// ./src/components/Dispositivos.js